// test1099
(1099 && 0);
